import { render, staticRenderFns } from "./BigQueryBillForm.vue?vue&type=template&id=20b7f000&scoped=true&"
import script from "./BigQueryBillForm.vue?vue&type=script&lang=js&"
export * from "./BigQueryBillForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b7f000",
  null
  
)

export default component.exports